'use client';

import { c as _c } from "react/compiler-runtime";
import { useLayoutEffect, useRef } from 'react';
import { type ShareChannelFieldId, useShareChannelFieldSvg } from '@/queries/share-channel-field-svg';
function mountShareFieldSvg(field: HTMLDivElement, svgMarkup: string): void {
  const parsed = new DOMParser().parseFromString(svgMarkup, 'image/svg+xml');
  const svg = parsed.documentElement;
  if (svg.tagName !== 'svg') {
    throw new Error('Parsed markup is not an SVG root');
  }
  const imported = document.importNode(svg, true);
  if (!(imported instanceof SVGSVGElement)) {
    throw new Error('Parsed markup is not an SVG element');
  }
  imported.setAttribute('preserveAspectRatio', 'xMaxYMid slice');
  imported.removeAttribute('width');
  imported.removeAttribute('height');
  field.replaceChildren(imported);
}
export function ShareChannelFieldBackground(t0) {
  const $ = _c(5);
  const {
    channel
  } = t0;
  const fieldRef = useRef(null);
  const {
    data: svgMarkup
  } = useShareChannelFieldSvg(channel);
  let t1;
  let t2;
  if ($[0] !== svgMarkup) {
    t1 = () => {
      const field = fieldRef.current;
      if (!field || svgMarkup === undefined) {
        return;
      }
      try {
        mountShareFieldSvg(field, svgMarkup);
      } catch {}
    };
    t2 = [svgMarkup];
    $[0] = svgMarkup;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useLayoutEffect(t1, t2);
  const t3 = `share-channel-field share-channel-field--${channel}`;
  let t4;
  if ($[3] !== t3) {
    t4 = <div ref={fieldRef} aria-hidden={true} className={t3} />;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
}